import { ConfigsState } from "./reducer"

export const getConfig = (state: { configs: ConfigsState }) => state.configs
export const getJiraLink = (state: { configs: ConfigsState }) => state.configs.jiraLink
